import { SVGProps } from 'react';

const Slack = ({ props }: { props?: SVGProps<SVGSVGElement>; size?: string | number }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56" fill="none" {...props}>
    <path
      fill="#E01E5A"
      d="M11.732 35.155a5.839 5.839 0 0 1-5.845 5.844 5.839 5.839 0 0 1-5.844-5.844 5.839 5.839 0 0 1 5.844-5.845h5.845v5.845Zm2.922 0A5.839 5.839 0 0 1 20.5 29.31a5.839 5.839 0 0 1 5.844 5.845v14.611a5.839 5.839 0 0 1-5.844 5.845 5.839 5.839 0 0 1-5.845-5.845V35.155Z"
    />
    <path
      fill="#36C5F0"
      d="M20.5 11.689a5.839 5.839 0 0 1-5.845-5.845A5.839 5.839 0 0 1 20.5 0a5.839 5.839 0 0 1 5.844 5.844v5.845H20.5Zm0 2.966a5.839 5.839 0 0 1 5.844 5.845 5.839 5.839 0 0 1-5.844 5.844H5.844A5.839 5.839 0 0 1 0 20.5a5.839 5.839 0 0 1 5.844-5.845H20.5Z"
    />
    <path
      fill="#2EB67D"
      d="M43.922 20.5a5.839 5.839 0 0 1 5.844-5.845 5.839 5.839 0 0 1 5.845 5.845 5.839 5.839 0 0 1-5.845 5.844h-5.844V20.5ZM41 20.5a5.839 5.839 0 0 1-5.845 5.844A5.839 5.839 0 0 1 29.31 20.5V5.844A5.839 5.839 0 0 1 35.156 0a5.839 5.839 0 0 1 5.844 5.844V20.5Z"
    />
    <path
      fill="#ECB22E"
      d="M35.155 43.922a5.839 5.839 0 0 1 5.844 5.844 5.839 5.839 0 0 1-5.844 5.845 5.839 5.839 0 0 1-5.845-5.845v-5.844h5.845Zm0-2.922a5.839 5.839 0 0 1-5.845-5.845 5.839 5.839 0 0 1 5.845-5.845H49.81a5.839 5.839 0 0 1 5.845 5.845 5.839 5.839 0 0 1-5.845 5.844H35.155Z"
    />
  </svg>
);

export default Slack;
